"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.visibleTransferOrchestrationStepKeys = exports.mergeTransferOutputWithDefaults = exports.TRANSFER_ORCHESTRATION_STEP_KEYS = void 0;
const index_1 = require("./index");
const normalizeLegacyTransferOutput_1 = require("./normalizeLegacyTransferOutput");
/** Canonical orchestration step order — shared by backend completion checks and UI timeline. */
exports.TRANSFER_ORCHESTRATION_STEP_KEYS = [
    "LinkCustomerToTargetSubsidiary",
    "CreateBillingAccount",
    "CreateNewSubscription",
    "SyncBothSubscriptions",
    "SubscriptionLinesAndPriceIntervals",
    "TerminateSubsciption",
    "ChangeCustomerPreferences",
    "VerifyCmInvoiceAmountParity",
    "CreateCreditMemo",
    "RenameCreditMemoToInternalOnly",
    "RevertPreferences",
    "CreateNewInvoice",
    "ApplyCustomerPayment",
    "ReconcileCreditMemoToInvoice",
    "CreateJournalEntry",
    "TurnOfAutoRenewal",
    "DeleteDraftSubscription",
];
/**
 * Ensures every orchestration step exists on output (legacy rows, API reads).
 * DDB values win over `initialTransferOutput` defaults.
 */
function mergeTransferOutputWithDefaults(output) {
    return {
        ...index_1.initialTransferOutput,
        ...(0, normalizeLegacyTransferOutput_1.normalizeLegacyTransferOutput)(output),
    };
}
exports.mergeTransferOutputWithDefaults = mergeTransferOutputWithDefaults;
/**
 * Steps to show in the Output Details grid. Hides NOT_INITIATED tiles on
 * terminal transfers so steps added after an old run do not appear as pending.
 */
function visibleTransferOrchestrationStepKeys(output, requestStatus) {
    const terminal = requestStatus === "COMPLETED" ||
        requestStatus === "FAILED" ||
        requestStatus === "CANCELLED";
    return exports.TRANSFER_ORCHESTRATION_STEP_KEYS.filter((key) => {
        const step = output[key];
        if (!step || typeof step !== "object" || !("status" in step)) {
            return !terminal;
        }
        const status = String(step.status ?? index_1.StepStatus.NOT_INITIATED);
        if (status !== index_1.StepStatus.NOT_INITIATED) {
            return true;
        }
        return !terminal;
    });
}
exports.visibleTransferOrchestrationStepKeys = visibleTransferOrchestrationStepKeys;
